const CART_KEY = "zaturday:roomOrderCart";
const CART_EVENT_KEY = "zaturday:roomOrderCartEventID";

export function loadOrderCart(eventID = "") {
  try {
    if (!eventID) {
      clearOrderCart();
      return [];
    }
    ensureCartEvent(eventID);
    const raw = localStorage.getItem(CART_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

export function saveOrderCart(items, eventID = "") {
  if (!eventID) {
    clearOrderCart();
    return;
  }
  if (eventID) {
    localStorage.setItem(CART_EVENT_KEY, eventID);
  }
  localStorage.setItem(CART_KEY, JSON.stringify(items || []));
}

export function clearOrderCart() {
  localStorage.removeItem(CART_KEY);
  localStorage.removeItem(CART_EVENT_KEY);
}

export function getOrderCartCount(eventID = "") {
  return loadOrderCart(eventID).reduce((total, item) => total + item.quantity, 0);
}

export function addOrderCartItem(menuItem, eventID = "") {
  if (!eventID) {
    clearOrderCart();
    return [];
  }
  const items = loadOrderCart(eventID);
  const temperatureOption = findSelectedOption(
    menuItem.temperatureOptions,
    menuItem.temperature
  );
  const sweetnessOption = findSelectedOption(
    menuItem.sweetnessOptions,
    menuItem.sweetness
  );
  const key = [
    menuItem.id,
    menuItem.temperature,
    menuItem.sweetness || "none",
  ].join("|");
  const existing = items.find((item) => item.key === key);

  if (existing) {
    existing.quantity += menuItem.quantity;
  } else {
    items.push({
      key,
      id: menuItem.id,
      name: menuItem.name,
      image: menuItem.imageKey || menuItem.image,
      temperature: temperatureOption ? temperatureOption.label : menuItem.temperature,
      temperatureID: menuItem.temperature,
      sweetness: sweetnessOption ? sweetnessOption.label : menuItem.sweetness || "",
      sweetnessID: menuItem.sweetness || null,
      quantity: menuItem.quantity,
    });
  }

  saveOrderCart(items, eventID);
  return items;
}

function ensureCartEvent(eventID) {
  if (!eventID) return;

  const currentEventID = localStorage.getItem(CART_EVENT_KEY);
  if (!currentEventID && localStorage.getItem(CART_KEY)) {
    localStorage.removeItem(CART_KEY);
  }
  if (currentEventID && currentEventID !== eventID) {
    localStorage.removeItem(CART_KEY);
  }
  localStorage.setItem(CART_EVENT_KEY, eventID);
}

function findSelectedOption(options, value) {
  return (options || []).find((option) => String(option.value) === String(value));
}
